import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { useResetGeometryEditor } from "../../LayerList/hooks/useResetGeometryEditor";
import { resetSelectedFeatures } from "../../../ducks/selectFeatures/selectFeatures";
import { resetEditFeatureChanges } from "../../../ducks/editFeature/editFeature";
import { resetFeatureToShow } from "../../../ducks/showFeature/showFeature";
import { setTableSelectedFeature } from "../../../ducks/table/table";

export const useResetFeatureSelect = () => {
  const dispatch = useDispatch();
  const resetGeometryEditor = useResetGeometryEditor();

  return useCallback(
    (resetWithSave?: boolean) => {
      dispatch(resetSelectedFeatures());
      dispatch(setTableSelectedFeature(undefined));
      resetGeometryEditor();
      dispatch(resetEditFeatureChanges(resetWithSave));
      dispatch(resetFeatureToShow());
    },
    [dispatch, resetGeometryEditor],
  );
};
